import { PageId } from 'constants/pages'
import { TPageConfig } from 'models/common.model'
import { THEMES } from 'root-constants'
import { PageIdWoofzPup } from './pages'

export const ID_TO_PAGE_CONFIG_MAP_WOOFZ_PUP: Record<
  Exclude<PageIdWoofzPup, PageIdWoofzPup.ACCOUNT_NOVE8>,
  TPageConfig
> = {
  [PageIdWoofzPup.DOG_AGE_PUP]: {
    id: PageIdWoofzPup.DOG_AGE_PUP,
    hasHeader: true,
  },
  [PageIdWoofzPup.DOG_OWNER_PUP]: {
    id: PageIdWoofzPup.DOG_OWNER_PUP,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPup.TRAINING_COMMANDS_PUP]: {
    id: PageIdWoofzPup.TRAINING_COMMANDS_PUP,
    hasHeader: true,
    progressBar: 'controlled',
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPup.URGE_PAGE_PUP]: {
    id: PageIdWoofzPup.URGE_PAGE_PUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.URGE,
  },
  [PageIdWoofzPup.DOG_BREED_PUP]: {
    id: PageIdWoofzPup.DOG_BREED_PUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPup.FACING_CHALLENGES_PUP]: {
    id: PageId.FACING_CHALLENGES_PUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPup.FACING_CHALLENGES_2_PUP]: {
    id: PageIdWoofzPup.FACING_CHALLENGES_2_PUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPup.BEHAVIOR_FREQUENCY_PUP]: {
    id: PageIdWoofzPup.BEHAVIOR_FREQUENCY_PUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPup.URGE_PROGRAM_PUP]: {
    id: PageIdWoofzPup.URGE_PROGRAM_PUP,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPup.BEHAVIOR_FEELINGS_PUP]: {
    id: PageIdWoofzPup.BEHAVIOR_FEELINGS_PUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPup.FIX_BEHAVIOR_PUP]: {
    id: PageIdWoofzPup.FIX_BEHAVIOR_PUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPup.URGE_PAGE_4_PUP]: {
    id: PageIdWoofzPup.URGE_PAGE_4_PUP,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPup.COMMANDS_PUP]: {
    id: PageIdWoofzPup.COMMANDS_PUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPup.PARENT_GOAL_PUP]: {
    id: PageIdWoofzPup.PARENT_GOAL_PUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPup.TRAINING_PLACE_PUP]: {
    id: PageIdWoofzPup.TRAINING_PLACE_PUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPup.TRAINING_FREQUENCY_PUP]: {
    id: PageIdWoofzPup.TRAINING_FREQUENCY_PUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    progressBar: 'controlled',
  },
  [PageIdWoofzPup.URGE_PAGE_5_PUP]: {
    id: PageIdWoofzPup.URGE_PAGE_5_PUP,
    hasHeader: true,
    hasHeaderBackButton: true,
    theme: THEMES.URGE,
  },
  [PageIdWoofzPup.PREPARE_FLOW_PUP]: {
    id: PageIdWoofzPup.PREPARE_FLOW_PUP,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPup.EMAIL_PUP]: {
    id: PageIdWoofzPup.EMAIL_PUP,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPup.NEWSLETTER_URGE_PUP]: {
    id: PageIdWoofzPup.NEWSLETTER_URGE_PUP,
    hasHeader: true,
    hasHeaderBackButton: true,
  },
  [PageIdWoofzPup.LAST_CHANCE_OFFER_PUP]: {
    id: PageIdWoofzPup.LAST_CHANCE_OFFER_PUP,
  },
  [PageIdWoofzPup.SUBSCRIPTIONS_PUP]: {
    id: PageIdWoofzPup.SUBSCRIPTIONS_PUP,
  },
  [PageIdWoofzPup.CHAT_UPSELL_PUP]: {
    id: PageIdWoofzPup.CHAT_UPSELL_PUP,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPup.UPSELL_PUP]: {
    id: PageIdWoofzPup.UPSELL_PUP,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPup.UPSELL_FEEDING_GUIDE_PUP]: {
    id: PageIdWoofzPup.UPSELL_FEEDING_GUIDE_PUP,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPup.UPSELL_EMOTIONAL_SUPPORT_PUP]: {
    id: PageIdWoofzPup.UPSELL_EMOTIONAL_SUPPORT_PUP,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
  [PageIdWoofzPup.DOWNLOAD_PUP]: {
    id: PageIdWoofzPup.DOWNLOAD_PUP,
    hasHeader: true,
    theme: THEMES.POLICY,
  },
}
